const templateFiles = require.context('.', false, /\.json$/)

export default templateFiles
  .keys()
  .sort()
  .map(file => templateFiles(file))
